import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useFormContext } from "react-hook-form";
import RangeSlider from "react-range-slider-input";

import { EditIcon } from "../../assets";
import { preferenceEnums, BUDGET_RANGE } from "../../system/global-enums";
import {
  numberFormatting,
  getSelectOptions,
  getOptionsFromEnums,
} from "../../shared/utility";
import CustomSelect from "../../shared/components/select/CustomSelect";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import { countryAction, propertyActions } from "../../redux/actions";

const {
  FAMILY,
  AGE_RANGE,
  TRAVEL_DISTANCE,
  HEALTH_PRIORITY,
  PROPERTIES_OWNS,
  DECISION_CHOICES,
  TRAVEL_DISTANCE_HOLIDAY,
} = preferenceEnums;

const Preferences = ({
  allHobbies,
  allCountries,
  allCurrencies,
  getAllCountries,
  allPropertyTypes,
  getAllPropertyTypes,
  allDayToDayActivity,
  isEditing,
  handleChangeEditor,
}) => {
  const { getValues, setValue, watch } = useFormContext();

  useEffect(() => {
    getAllCountries();
    getAllPropertyTypes();

    getCurrencyCode();
    // eslint-disable-next-line
  }, []);

  const getCurrencyCode = () => {
    const selectedCurrency = getValues("defaultCurrencyId");
    return (
      allCurrencies?.find(
        (currency) => Number(selectedCurrency) === currency?.id
      )?.code || "USD"
    );
  };

  const currencyCode = getCurrencyCode();

  return (
    <div className="grey-bg-wrapper">
      <div className="d-flex justify-content-between">
        <div className="heading">Preferences</div>
        {!isEditing && (
          <div
            className="edit-button pointer"
            onClick={() => handleChangeEditor(true)}
          >
            <img src={EditIcon} alt="edit-icon" />
            Edit
          </div>
        )}
      </div>

      <div className="heading sub-heading">Age</div>

      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(AGE_RANGE)}
          placeholder="Age Group"
          name="ageGroup"
        />
      </div>
      <div className="heading sub-heading">Owns a home:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(
            preferenceEnums.DECISION_CHOICES_BOOLEAN
          )}
          name="ownsHouse"
          placeholder="Owns Home"
        />
      </div>
      <div className="heading sub-heading">Family Members:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(FAMILY)}
          name="familyMemberIds"
          placeholder="Family"
          isMulti
        />
      </div>
      <div className="heading sub-heading">Passports:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allCountries, "name", "id")}
          name="passportHold"
          placeholder="Passports"
          isMulti
        />
      </div>
      <div className="heading sub-heading">Current Country of Residence:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allCountries, "name", "id")}
          name="currentCountry"
          placeholder="Current Country of Residence"
        />
      </div>
      <div className="heading sub-heading">Places like to live:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allPropertyTypes, "title", "id")}
          name="preferredLocationIds"
          placeholder="Places like to live"
          isMulti
        />
      </div>
      <div className="heading sub-heading">No. of properties like to own:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(PROPERTIES_OWNS)}
          name="noPropertiesLikeToOwn"
          placeholder="Properties like to own"
        />
      </div>
      <div className="heading sub-heading">Healthcare:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(HEALTH_PRIORITY)}
          name="healthPriority"
          placeholder="Healthcare"
        />
      </div>
      <div className="heading sub-heading">Day to day activities:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allDayToDayActivity, "title", "id")}
          name="dayToDay"
          isMulti
          placeholder="Day to day activities"
        />
      </div>
      <div className="heading sub-heading">Tax free Country:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(DECISION_CHOICES)}
          name="taxFreeCountry"
          placeholder="Tax free country"
        />
      </div>
      <div className="heading sub-heading">Countries like to live:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allCountries, "name", "id")}
          name="countriesLikeToLiveIds"
          placeholder="Countries where you'd like to live"
          isMulti
        />
      </div>
      <div className="heading sub-heading">Visa free country:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(DECISION_CHOICES)}
          name="visaFreeCountry"
          placeholder="Visa free country"
        />
      </div>
      <div className="heading sub-heading">Citizenship:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allCountries, "name", "id")}
          name="interestedCitizenshipId"
          placeholder="Interested Citizenship"
        />
      </div>
      <div className="heading sub-heading">Flight time for travelling:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(TRAVEL_DISTANCE_HOLIDAY)}
          name="travelDistanceHoliday"
          placeholder="Traveling flight time"
        />
      </div>
      <div className="heading sub-heading">Proximity to loved ones:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getOptionsFromEnums(TRAVEL_DISTANCE)}
          name="travelDistanceLovedOnes"
          placeholder="Flight time to loved ones"
        />
      </div>
      <div className="heading sub-heading">Hobbies and interests:</div>
      <div className="input-field">
        <CustomSelect
          isEditing={isEditing}
          options={getSelectOptions(allHobbies, "title", "id")}
          name="hobbies"
          placeholder="Hobbies and interests"
          isMulti
        />
      </div>

      <div className="heading sub-heading">Budget</div>
      <div className="input-field d-flex gap-5">
        {isEditing ? (
          <div className="w-100 mt-3">
            <RangeSlider
              value={[watch("minBudget"), watch("maxBudget")]}
              onInput={(e) => {
                setValue("minBudget", e[0]);
                setValue("maxBudget", e[1]);
              }}
              min={BUDGET_RANGE.MIN}
              max={BUDGET_RANGE.MAX}
            />
            <div className="mt-2 d-flex justify-content-between align-items-center range-values">
              <div>
                {numberFormatting(getValues("minBudget"))} {currencyCode}
              </div>
              {/* If the max value is reached, show '1 million +' */}
              <div>
                {getValues("maxBudget") === BUDGET_RANGE.MAX
                  ? `1M+ ${currencyCode}`
                  : `${numberFormatting(
                      getValues("maxBudget")
                    )} ${currencyCode}`}
              </div>
            </div>
          </div>
        ) : (
          <>
            {numberFormatting(getValues("minBudget"))} -{" "}
            {getValues("maxBudget") === BUDGET_RANGE.MAX
              ? "1M+"
              : numberFormatting(getValues("maxBudget"))}{" "}
            {currencyCode}
          </>
        )}
      </div>
      {isEditing && (
        <div className="mt-4 d-flex justify-content-center gap-3">
          <RoundedButton className="px-4 px-md-5 py-1" type="submit">
            Update
          </RoundedButton>
          <RoundedButton
            className="px-4 px-md-5 py-1"
            variant="outlined"
            onClick={() => handleChangeEditor(false)}
          >
            Cancel
          </RoundedButton>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  allHobbies: state.homeReducer.allHobbies,
  allCountries: state.countryReducer.allCountries,
  allPropertyTypes: state.propertyReducer.allPropertyTypes,
  allDayToDayActivity: state.homeReducer.allDayToDayActivity,
});

const mapDispatchToProps = (dispatch) => ({
  getAllCountries: () => dispatch(countryAction.getAllCountries()),
  getAllPropertyTypes: () => dispatch(propertyActions.getAllPropertyTypes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Preferences);
